import { createPortal } from 'react-dom'

export function TutorialLoadingModal() {
  return createPortal(
    <div className="tutorial-loading-modal">
      <div className="tutorial-loading-content">
        <div className="tutorial-loading-spinner" />
        <div className="tutorial-loading-text">
          Starting tutorial...
        </div>
      </div>
    </div>,
    document.body,
  )
}
